import { fireInView } from '../tools/utilities/section-tools';
import { responsiveMediaAbove } from '../settings/responsive';

const SELECTOR_NEWSLETTER = '[data-newsletter-container]';
const SELECTOR_NEWSLETTER_INNER = '[data-newsletter-inner]';
const SELECTOR_CONTAINER = '[data-newsletter]';

const CLASS_ANIMATED = 'is-animated';

document.querySelectorAll(SELECTOR_CONTAINER).forEach((container) => {
  const newsletterInner = container.querySelector<HTMLElement>(
    SELECTOR_NEWSLETTER_INNER
  );
  const newsltterContainer =
    container.querySelector<HTMLElement>(SELECTOR_NEWSLETTER);
  let threshold;

  if (responsiveMediaAbove('MEDIUM')) {
    threshold = 0.2;
  } else {
    threshold = 0.7;
  }

  const revealNewsletter = () => {
    if (!newsletterInner || !newsltterContainer) return;
    newsltterContainer.classList.add(CLASS_ANIMATED);
  };

  // Add animated class when newsletter is in view
  if (newsletterInner) {
    fireInView(newsletterInner, revealNewsletter, 0.7);
  }
});
